import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import RoadmapPage from './components/RoadmapPage';
import { SessionProvider } from './contexts/SessionContext';

const App: React.FC = () => {
  return (
    <SessionProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/auth/callback" element={<Layout />} />
          <Route path="/logout-callback" element={<Layout />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </SessionProvider>
  );
};

export default App;
